import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setColorbar } from "../../redux/colorbars";
import { DEFAULT_COLORBAR_RANGE_MODE } from "./colorbarConstants";
import Button from "./Button";
import ColorbarSetRangeModal from "./ColorbarSetRangeModal";
import "./colorBar.css";
import { createPortal } from "react-dom";
import { getStepForSlider } from "../utils";

const ColorbarSetRange = ({
  category,
  subcategory,
  defaultMin,
  defaultMax,
  colorbarMin,
  colorbarMax,
}) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const stored = useSelector(
    (state) => state.colorbars[category]?.[subcategory],
  );
  const initialRange = [colorbarMin ?? defaultMin, colorbarMax ?? defaultMax];
  const [value, setValue] = useState(initialRange);
  const [rangeMode, setRangeMode] = useState(
    stored?.rangeMode ?? DEFAULT_COLORBAR_RANGE_MODE,
  );

  useEffect(() => {
    setValue([colorbarMin ?? defaultMin, colorbarMax ?? defaultMax]);
  }, [category, subcategory, colorbarMin, defaultMin, colorbarMax, defaultMax]);

  useEffect(() => {
    setRangeMode(stored?.rangeMode ?? DEFAULT_COLORBAR_RANGE_MODE);
  }, [category, subcategory, stored?.rangeMode]);

  const sliderMin = Math.min(defaultMin, value[0], initialRange[0]);
  const sliderMax = Math.max(defaultMax, value[1], initialRange[1]);
  const step = getStepForSlider(defaultMax);

  const handleConfirm = () => {
    dispatch(
      setColorbar([
        category,
        subcategory,
        Number(value[0]),
        Number(value[1]),
        rangeMode,
      ]),
    );
    setShow(false);
  };

  const handleCancel = () => {
    setShow(false);
    setValue(initialRange);
    setRangeMode(stored?.rangeMode ?? DEFAULT_COLORBAR_RANGE_MODE);
  };

  return (
    <>
      <Button variant="text" onClick={() => setShow(true)}>
        Set Range
      </Button>

      {show &&
        createPortal(
          <>
            <div
              className="colorbar-set-range-backdrop"
              onClick={handleCancel}
            />
            <ColorbarSetRangeModal
              category={category}
              subcategory={subcategory}
              sliderMin={sliderMin}
              sliderMax={sliderMax}
              value={value}
              onValueChange={setValue}
              rangeMode={rangeMode}
              onRangeModeChange={setRangeMode}
              step={step}
              onConfirm={handleConfirm}
              onCancel={handleCancel}
            />
          </>,
          document.body,
        )}
    </>
  );
};

export default ColorbarSetRange;
